import { render, staticRenderFns } from "./ProgramStats.vue?vue&type=template&id=cdba0868&scoped=true&"
import script from "./ProgramStats.vue?vue&type=script&lang=js&"
export * from "./ProgramStats.vue?vue&type=script&lang=js&"
import style0 from "./ProgramStats.vue?vue&type=style&index=0&id=cdba0868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdba0868",
  null
  
)

export default component.exports